import { ITooltipHostStyles } from "@fluentui/react";

export const tooltipHostStyles: ITooltipHostStyles = {
    root: { display: "inline-block" },
  };